<template>
  <div class="col">
      <div class="col text-left">
        <div class="container-fluid">
          <div class="row align-items-center">
            <h1 class="my-auto">Projects list</h1>
            <ProjectAdder v-on:project-added="addProject"
                          v-on:project-added-error="addProjectError"/>
          </div>
          <CardsProjects v-bind:columns="columns"
                         v-bind:projects="projects"
                         v-on:select-project="selectProject($event)"
                         v-on:delete-project="deleteProject($event)"
                         v-on:delete-collection="deleteCollection"
                         v-on:collection-added="addCollection"
                         v-on:collection-added-error="addCollectionError"></CardsProjects>
        </div>
        <div class="row align-items-center" :style="{'min-height': '50px'}">
          <div class="col"></div>
        </div>
      </div>

  </div>
</template>
<script>
import ProjectAdder from '@/components/project/ProjectAdder.vue'
import CardsProjects from "./CardsProjects";
import ProjectApi from '../../generatedApiClient/api/endpoints/ProjectApi';
import MessageDisplayerService from '../../utils/MessageDisplayerService';

let projectApiInstance = new ProjectApi();


export default {
  name: "ProjectsList",
  props: ['projects','columns'],
  components: {
    CardsProjects,
    ProjectAdder
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    signedUser: function () {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    selectProject: function(project){
      this.$emit('select-project',project )

    },
    deleteProject: function (projectId) {
      this.updateAuthJwtToken(projectApiInstance);
      projectApiInstance.deleteProject(this.signedUser, projectId)
          .then(deleteProjectResp => {
            console.log("[deleteProject] [API] [deleteProject] [OK]" + deleteProjectResp);
            this.$emit('a-project-was-deleted', {});
            MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_DELETE_PROJECT);
          })
          .catch(deleteProjectError => {
            MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_DELETE_PROJECT, deleteProjectError);
          });
    },
    deleteCollection: function (userId, projectId, collectionName) {
      console.log(userId + projectId + collectionName)
      this.updateAuthJwtToken(projectApiInstance);
      projectApiInstance.deleteCollection(userId, projectId, collectionName)
          .then(deleteCollectionResp => {
            console.log("[deleteCollection] [API] [deleteCollection] [OK]" + deleteCollectionResp);
            // refresh
            this.$emit('a-project-was-deleted', {});
            MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_DELETE_COLLECTION);
          })
          .catch(deleteCollectionError => {
            MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_DELETE_COLLECTION, deleteCollectionError);
          });
    },
    addProject: function () {
      this.$emit('a-project-was-created', {});

    },
    addProjectError: function (createProjectError) {
      console.log('[addProject] error: ' + createProjectError);

    },
    addCollection: function () {
      // same as project creation
      this.$emit('a-project-was-created', {});

    },
    addCollectionError: function (addCollectionError) {
      console.log('[addCollection] error: ' + addCollectionError);

    },
  }
};
</script>
<styles scoped>
.cards {
display: flex;
flex-wrap: wrap;
}

.card {
flex: 1 0 200px;
box-sizing: border-box;
margin: 1rem .25em;
}

@media screen and (min-width: 20em) {

.card {
flex: 0 1 calc(50% - 1em);
}
}

@media screen and (min-width: 40em) {


.card {
flex: 0 1 calc(25% - 1em);
}
}

@media screen and (min-width: 80em) {


.card {
flex: 0 1 calc(12% - 0.5em);
}
}

.alertClose {
position:absolute;
top:2px;
margin: 0;
padding: 0;
}
</styles>